<template>
  <div>
    <v-row>
      <v-col cols="9">
        <v-row>
          <v-card class="mx-auto" width="95%">
            <v-card-title>
              <v-toolbar-title>Publicações</v-toolbar-title>
            </v-card-title>
            <v-toolbar color="darken-1" class="mb-1" elevation="0">
              <v-row>
                <v-col cols="12" sm="12" md="5">
                  <mb-text-field
                    label="Buscar por titulo"
                    prependInnerIcon="search"
                    @click:clear="limparTexto()"
                    v-model="buscar.titulo"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <ComboGrupo
                    v-model="buscar.tipo"
                    color="black"
                    label="Filtrar por tipo"
                    :exibirTodos="true"
                    :multiple="false"
                  />
                </v-col>
              </v-row>
            </v-toolbar>
            <v-card-text>
              <v-data-table
                :headers="columnsPublicacao"
                :items="publicacoesFiltradas"
                :items-per-page="20"
                class="elevation-0"
                ref="sortableTable"
                show-expand
                :footer-props="{
                  itemsPerPageOptions: [20,40,60,100],
                  'items-per-page-text':'publicações por página'
                }"
              >
                <template v-slot:item="row">
                  <tr
                    v-if="row.item"
                    class="sortableRow"
                    :key="itemKey(row.item)"
                    @click="row.expanded = !row.expanded"
                  >
                    <td>
                      <v-btn
                        style="cursor: move"
                        icon
                        class="sortHandle"
                        title="Ordenar publicação"
                      >
                        <v-icon>drag_handle</v-icon>
                      </v-btn>
                    </td>
                    <td style="text-align: left">
                      <span
                        tabindex="-1"
                        class="v-chip theme--dark v-size--default"
                        :style="[row.item.grupo.descricao === 'Principal' ? {backgroundColor:'#2d3f50'} :
                                      row.item.grupo.descricao === 'Nota' ? {backgroundColor:'#96a5a6'} :
                                      row.item.grupo.descricao === 'Eu Recomendo' ? {backgroundColor:'#8c45ad'} :
                                      row.item.grupo.descricao === 'Entrevista' ? {backgroundColor:'#239f85'} :
                                      row.item.grupo.descricao === 'Em Alta' ? {backgroundColor:'#2f81b7'} :
                                      row.item.grupo.descricao === 'Anúncio' ? {backgroundColor:'#ee8e24'} :
                                      row.item.grupo.descricao === 'Em Baixa' ? {backgroundColor:'#be3a31'} : {}]"
                      >
                        <span class="v-chip__content">{{ row.item.grupo.descricao }}</span>
                      </span>
                    </td>
                    <td style="text-align: left">{{ row.item.titulo }}</td>
                    <td style="text-align: left">
                      <div v-if="!row.item.texto"></div>
                      <div v-else-if="row.item.texto.length < 100" v-html="row.item.texto"></div>
                      <div v-else v-html="row.item.texto.substring(0,100)+'...'"></div>
                    </td>
                    <td style="text-align: left">{{ row.item.ordem }}</td>
                    <td style="text-align: right">
                      <v-btn
                        x-small
                        class="mb-2"
                        text
                        @click="mostrarDialogEditarPublicacao(row.item)"
                        v-if="row.item.grupo.descricao !== 'Anúncio'"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      <v-btn
                        x-small
                        class="mb-2"
                        text
                        @click="deletarPublicacao(row.item.id)"
                        title="Remover"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
            <v-toolbar color="darken-1" class="mb-1" elevation="0">
              <v-btn
                dark
                rounded
                color="darken-2"
                class="text-transform-none"
                @click="mostrarDialogCadastroPublicacao()"
              >
                <v-icon>add</v-icon>Nova Publicação
              </v-btn>
              <v-btn
                rounded
                outlined
                color="darken-2"
                class="text-transform-none"
                style="margin-left: 10px"
                title="Ordena as publicações por tido de forma automática"
                @click="ordenarPublicacaoAutomatica()"
                v-if="false"
              >
                <v-icon>sort</v-icon>Ordenar Automáticamente
              </v-btn>
            </v-toolbar>
          </v-card>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row>
          <v-card class="mx-left" width="90%">
            <v-card-title>
              <v-toolbar-title>Anúncios</v-toolbar-title>
              <v-spacer />
              <v-btn
                dark
                fab
                color="darken-2"
                class="text-transform-none"
                title="Novo Anúncio"
                v-if="userAdmin"
                @click="mostrarDialogCadastroAnuncio()"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :items-per-page="15"
                class="elevation-0"
                hide-default-footer
                :headers="columnsAnuncio"
                :items="anuncios"
              >
                <template v-slot:item="row">
                  <tr>
                    <td style="text-align: left">{{ row.item.titulo }}</td>
                    <td style="text-align: left">
                      <v-btn
                        x-small
                        class="mb-2"
                        text
                        @click="incuirAnuncio(row.item)"
                        title="Adicionar Anúncio"
                      >
                        <v-icon dark>reply</v-icon>
                      </v-btn>
                      <v-btn
                        x-small
                        class="mb-2"
                        text
                        @click="mostrarImagensAnuncio(row.item)"
                        title="Visualizar Imagem"
                      >
                        <v-icon dark>image</v-icon>
                      </v-btn>
                      <v-btn
                        x-small
                        class="mb-2"
                        text
                        @click="deletarAnuncio(row.item.id)"
                        title="Remover"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
            <v-toolbar color="darken-1" class="mb-1" elevation="0">
              <v-btn
                outlined
                rounded
                color="darken-2"
                class="text-transform-none"
                title="Adiciona todos os anúncios listados acima"
                @click="mostrarDialogCadastroAnuncio()"
              >
                <v-icon>reply_all</v-icon>Adicionar Anúncios
              </v-btn>
            </v-toolbar>
          </v-card>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="dlgFormPublicacao" transition="dialog-bottom-transition">
      <FormPublicacao
        v-if="dlgFormPublicacao"
        @salvar="salvarPublicacao"
        @fechar="fecharDlgPublicacao"
        :isNovo="isNew"
        :setPublicacao="publicacao"
      />
    </v-dialog>

    <v-dialog v-model="dlgFormAnuncio" transition="dialog-bottom-transition">
      <FormAnuncio
        v-if="dlgFormAnuncio"
        @salvar="salvarAnuncio"
        @fechar="fecharDlgAnuncio"
        :isNovo="isNew"
        :setAnuncio="anuncio"
      />
    </v-dialog>

    <v-dialog v-model="dlgImageAnuncio" transition="dialog-bottom-transition" width="500">
      <v-card v-if="dlgImageAnuncio">
        <v-toolbar dark color="darken-2" elevation="0" @short="true">
          <v-btn icon dark @click="fecharDlgImagemAnuncio()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span>Visualizar Imagens</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-carousel cycle hide-delimiter-background show-arrows-on-hover style="margin-top: 25px">
            <v-carousel-item v-for="(image, i) in anuncioImagens" :key="i">
              <v-img :src="image" aspect-ratio="1" contain />
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PublicacaoInput from "@/classes/publicacaoInput.js";
import AnuncioInput from "@/classes/anuncioInput.js";
import FormPublicacao from "@/views/publicacao/FormPublicacao.vue";
import FormAnuncio from "@/views/publicacao/FormAnuncio.vue";
import PublicacaService from "@/services/publicacaoService.js";
import ComboGrupo from "@/widget/ComboGrupos.vue";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      userAdmin: false,
      editorialId: null,
      publicacao: new PublicacaoInput(),
      anuncio: new AnuncioInput(),
      dlgFormPublicacao: false,
      dlgFormAnuncio: false,
      dlgImageAnuncio: false,
      dlgIteracao: false,
      isNew: true,
      quantidadeVisualizacoes: 0,
      quantidadeCurtidas: 0,
      loadingIteracao: false,
      mockphone1: require("../../assets/phone1.png"),
      anuncioImagens: [],
      anuncios: [],
      columnsAnuncio: [
        { text: "Anunciante", align: "left" },
        { text: "", align: "right" },
      ],
      publicacoes: [],
      columnsPublicacao: [
        { text: "Tipo", align: "left", width: "1%" },
        { text: "Titulo", align: "left", width: "20%" },
        { text: "Texto", align: "left", width: "58%" },
        { text: "Ordem", align: "left", width: "1%" },
        { text: "", align: "right", width: "20%" },
      ],
      buscar: {
        titulo: null,
        tipo: null,
      },

      itemKeys: new WeakMap(),
      currentItemKey: 0,
    };
  },
  methods: {
    async carregarAnuncios() {
      var result = await PublicacaService.listarAnuncio();
      this.anuncios = result.data.data.listarAnuncio;
    },
    async carregarListaPublicado() {
      var result = await PublicacaService.listarPublicacaoByEditorial(
        this.editorialId
      );
      this.publicacoes = result.data.data.listarPublicacaoByEditorial;
      console.log(this.publicacoes);
    },
    mostrarDialogCadastroPublicacao() {
      this.isNew = true;
      this.publicacao = new PublicacaoInput();
      this.dlgFormPublicacao = true;
    },
    mostrarDialogEditarPublicacao(value) {
      this.isNew = false;
      this.publicacao = value;
      this.dlgFormPublicacao = true;
    },
    fecharDlgPublicacao() {
      this.dlgFormPublicacao = false;
    },
    salvarPublicacao(value) {
      this.publicacao = value;
      this.publicacao.editorial_id = this.editorialId;
      if (this.isNew) {
        PublicacaService.criarPublicacao(this.publicacao).then(
          async (result) => {
            if (result.data.errors) {
              this.$toast.error(result.data.errors);
            } else {
              this.$toast.info("Publicação salva com sucesso.");
              await this.ordenarPublicacaoAutomatica();
              // await this.carregarListaPublicado();
              // await this.ordenarPublicacao();
              this.dlgFormPublicacao = false;
            }
          }
        );
      } else {
        PublicacaService.atualizarPublicacao(this.publicacao).then(
          async (result) => {
            if (result.data.errors) {
              this.$toast.error(result.data.errors);
            } else {
              this.$toast.info("Publicação atualizada com sucesso.");
              await this.carregarListaPublicado();
              this.dlgFormPublicacao = false;
            }
          }
        );
      }
    },
    async deletarPublicacao(publicacaoId) {
      var result = await PublicacaService.deletarPublicacao(publicacaoId);
      if (result.data.errors) {
        this.$toast.error("Não é possivel remover a publicacao.");
      } else {
        this.$toast.info("Publicação removido com sucesso.");
        await this.carregarListaPublicado();
        await this.ordenarPublicacao();
      }
    },
    async ordenarPublicacao() {
      var arrayPub = [];
      this.publicacoes.forEach(function (val, index) {
        val.ordem = index + 1;
        arrayPub.push({
          id: val.id,
          ordem: val.ordem,
        });
      });

      await PublicacaService.atualizarOrdemPublicacao(arrayPub);
    },
    async ordenarPublicacaoAutomatica() {
      await PublicacaService.ordenarPublicacao(this.editorialId);
      await this.carregarListaPublicado();
    },
    mostrarDialogCadastroAnuncio() {
      this.isNew = true;
      this.anuncio = new AnuncioInput();
      this.dlgFormAnuncio = true;
    },
    salvarAnuncio(value) {
      this.anuncio = value;
      if (this.isNew) {
        PublicacaService.criarAnuncio(this.anuncio).then(async (result) => {
          if (result.data.errors) {
            this.$toast.error(result.data.errors);
          } else {
            this.$toast.info("Anúncio salva com sucesso.");
            await this.carregarAnuncios();
            this.dlgFormAnuncio = false;
          }
        });
      }
    },
    incuirAnuncio(value) {
      PublicacaService.clonarPublicacao(value.id, this.editorialId, 0).then(
        async (result) => {
          if (result.data.errors) {
            this.$toast.error(result.data.errors);
          } else {
            this.$toast.info("Anúncio salva com sucesso.");
            await this.ordenarPublicacaoAutomatica();
            // await this.carregarListaPublicado();
            // await this.ordenarPublicacao();
          }
        }
      );
    },
    mostrarImagensAnuncio(anuncio) {
      this.anuncioImagens = [];
      for (var i = 0; i < anuncio.midia.length; i++) {
        const midia = anuncio.midia[i];
        for (var j = 0; j < midia.imagem.length; j++) {
          const imagem = midia.imagem[j];
          if (this.$utils.isNotNull(imagem)) {
            this.anuncioImagens.push(imagem);
          }
        }
      }
      this.dlgImageAnuncio = true;
    },
    async deletarAnuncio(publicacaoId) {
      var result = await PublicacaService.deletarPublicacao(publicacaoId);
      if (result.data.errors) {
        this.$toast.error("Não é possivel remover o anúncio.");
      } else {
        this.$toast.info("Anúncio removido com sucesso.");
        await this.carregarAnuncios();
      }
    },
    fecharDlgAnuncio() {
      this.dlgFormAnuncio = false;
    },
    fecharDlgImagemAnuncio() {
      this.dlgImageAnuncio = false;
    },
    async dragReorder({ oldIndex, newIndex }) {
      const movedItem = this.publicacoes.splice(oldIndex, 1)[0];
      console.log(movedItem);
      this.publicacoes.splice(newIndex, 0, movedItem);

      await this.ordenarPublicacao();
      await this.carregarListaPublicado();
    },
    itemKey(item) {
      if (item) {
        if (!this.itemKeys.has(item))
          this.itemKeys.set(item, ++this.currentItemKey);
        return this.itemKeys.get(item);
      } else {
        return Math.floor(Math.random() * 10000);
      }
    },
  },
  created() {
    this.userAdmin = this.$store.getters["usuario/isAdminUser"];
    this.editorialId = this.$route.params.id;
    this.carregarListaPublicado();
    this.carregarAnuncios();
  },
  beforeCreate() {},
  mounted() {
    new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName("tbody")[0],
      {
        draggable: ".sortableRow",
        handle: ".sortHandle",
        onEnd: this.dragReorder,
      }
    );
  },
  computed: {
    publicacoesFiltradas() {
      return this.publicacoes.filter((d) => {
        return (
          (this.buscar.titulo === null ||
            d.titulo
              .toLowerCase()
              .includes(this.buscar.titulo.toLowerCase())) &&
          (this.buscar.tipo === null ||
            this.buscar.tipo.id === null ||
            d.grupo.id === this.buscar.tipo.id)
        );
      });
    },
  },
  components: {
    FormPublicacao,
    ComboGrupo,
    FormAnuncio,
  },
};
</script>

<style>
.mock-phone {
  width: 100%;
  height: 100%;
  /*padding-left: 20px;*/
  padding-top: 60px;
  padding-right: 28px;
  /* background-color: green; */
  padding-bottom: 50px;
}
</style>
